import { useTranslation } from 'react-i18next';
import { CardDisclosure } from '@components/card-disclosure';
import { WARNING } from '@components/card-disclosure/src/card-disclosure.type';
import { IconWarning } from '@components/icons';
import { LabelPrimary } from '@components/label';
import { ModalStickyFooter } from '@components/modals/modal-sticky-footer';

import { createRowErrors } from '../utils/create-row-errors';

export const ConfirmImportCsv = ({
  qrWarnings,
  onContinue,
  onBack,
}: {
  qrWarnings: { emptyRows: number[]; duplicateRows: number[] };
  onContinue: () => void;
  onBack: () => void;
}) => {
  const { emptyRows, duplicateRows } = qrWarnings;
  const { t } = useTranslation();
  return (
    <div className='relative'>
      <header className='flex flex-col gap-5 pt-8 mb-8 px-6'>
        <div className='flex gap-3 w-full'>
          <IconWarning className='w-8 h-8 text-orange-400' />
          <h2 className='flex items-center gap-3 text-headline-l text-left text-headline text-primary'>
            <LabelPrimary>{t('common:confirmImportCsvTitle')}</LabelPrimary>
          </h2>
        </div>
        <p className='text-sm text-secondary'>{t('common:confirmImportCsvDescription')}</p>
      </header>
      <div className='flex flex-col gap-3 px-6 mb-6'>
        {emptyRows.length > 0 && (
          <CardDisclosure
            titleText={t('common:emptyRows')}
            descriptionText={`${t('common:rows')}: ${createRowErrors(emptyRows)}`}
            showChevronIcon
            variant={WARNING}
            isDefaultOpen
          />
        )}
        {duplicateRows.length > 0 && (
          <CardDisclosure
            titleText={t('common:duplicatedRows')}
            descriptionText={`${t('common:rows')}: ${createRowErrors(duplicateRows)}`}
            showChevronIcon
            variant={WARNING}
            isDefaultOpen
          />
        )}
      </div>

      <ModalStickyFooter
        primaryButtonText={t('common:startImportButton')}
        onPrimaryButtonClick={onContinue}
        onSecondaryButtonClick={onBack}
        secondaryButtonText={t('common:backButton')}
        isAccent
      />
    </div>
  );
};
